import React, { useState } from "react";
import { getAuth, signInWithEmailAndPassword, deleteUser } from "firebase/auth";
import { useNavigate, useLocation } from "react-router-dom";
import "../css/popup.css";

export default function Delete_User() {
  const navigate = useNavigate();
  const location = useLocation();
  const user_id = location.state.id;
  const [data, getData] = useState([]);
  const token = JSON.parse(sessionStorage.getItem("userToken"));
  const user_email = location.state.email;
  // console.log(`----------> ${JSON.stringify(location.state)}`);

  const handleDeleteUserFromMongoDB = async () => {
    try {
      const response = await fetch(
        "https://serverpickload.wl.r.appspot.com/admin_delete/delete_user",
        {
          method: "POST",
          body: JSON.stringify({
            token: token,
            user_id: user_id,
          }),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
          },
        }
      );

      // Parse the JSON response
      const result = await response.json();

      // Process data (if necessary)
      getData(result.user);

      // If API call is successful, status code is 200
      // if (response.status === 200) {
      //   // Now sign in to Firebase and delete the user
      //   await handleFirebaseAccountDeletion();
      // } else {
      //   alert("Failed to delete user. Please try again.");
      // }
    } catch (error) {
      console.error("Error during the API request:", error);
      alert("An error occurred while deleting the user. Please try again.");
    }
  };

  // Function to handle Firebase sign-in and account deletion
  const handleFirebaseAccountDeletion = async () => {
    const auth = getAuth();

    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        user_email,
        "pickload_user"
      );
      const user = userCredential.user;

      if (user?.uid) {
        // Delete the user in Firebase
        await deleteUser(user);
        console.log("Firebase account deleted successfully.");
        handleDeleteUserFromMongoDB();
      } else {
        alert("An error occurred. Could not find user in Firebase.");
      }
    } catch (error) {
      console.error(
        "Error signing in or deleting Firebase account:",
        error.message
      );
      alert("Error deleting Firebase account: " + error.message);
    }
  };

  // const handleDeleteUserFromMongoDB = async () => {
  //   try {
  //     const response = await fetch(
  //       "https://serverpickload.wl.r.appspot.com/admin_delete/delete_user",
  //       {
  //         method: "POST",

  //         body: JSON.stringify({
  //           token: token,
  //           user_id: user_id,
  //         }),
  //         headers: {
  //           "Content-Type": "application/json",
  //           Accept: "application/json, text/plain, */*",
  //         },
  //       }
  //     );
  //     const result = await response.json();
  //     //console.log(result.user);
  //     getData(result.user);
  //     //console.log('got here');
  //     //console.log(result);
  //     //console.log(data.vehicle_details, data.bank_details);

  //     if (response.status === 200) {
  //       //console.log('data gotten succesfully');
  //     } else {
  //       //console.log('some error occurred');
  //     }
  //   } catch (error) {
  //     //console.log(error);
  //   }
  // };
  return (
    <div className="popup">
      <div className="popup-container">
        <div className="popup-background">
          <div className="popup-confirmation">
            <div className="popup-confirmation-info">
              Delete user Confirmation
            </div>
            <div className="popup-rematched">
              Are you sure you want to Delete this<br></br> user?
            </div>
          </div>
          <div className="popup-dialog-row">
            <div
              className="popup-dialog"
              onClick={() => navigate("/App/Users")}
            >
              No
            </div>
            <div className="middle-line">
              <hr className="popup-hr"></hr>
            </div>
            <div
              className="popup-dialog1"
              onClick={() => {
                handleFirebaseAccountDeletion();
                navigate("/App/Users");
              }}
            >
              Yes
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
